import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { SbSharedContentModuleStorytellingCard } from './SbSharedContentModuleStorytellingCard.tsx';
import { type SbSharedContentModuleStorytellingWrapper_storytellingModule$key } from './__generated__/SbSharedContentModuleStorytellingWrapper_storytellingModule.graphql.ts';

import styles from './SbSharedContentModuleStorytelling.scss';

const getStorytellingModulesConfig = (
    itemsPerRow: 3 | 5
): Record<number, { moduleIndex: number; isAlternate: boolean }> => {
    const everyTwoRows = itemsPerRow * 2;
    return {
        0: { moduleIndex: 0, isAlternate: false },
        [everyTwoRows]: { moduleIndex: 1, isAlternate: true },
        [everyTwoRows * 2]: { moduleIndex: 2, isAlternate: false },
    };
};

const fragment = graphql`
    fragment SbSharedContentModuleStorytellingWrapper_storytellingModule on ContentModuleStorytelling {
        storytellingModules {
            ...SbSharedContentModuleStorytellingCard_storytellingModule
        }
    }
`;

type Props = {
    contentModule:
        | SbSharedContentModuleStorytellingWrapper_storytellingModule$key
        | null
        | undefined;
    index: number;
    isMobile?: boolean;
    pageCol?: 3 | 5;
};

export const SbSharedContentModuleStorytellingWrapper: FC<Props> = ({
    contentModule: contentModuleRef,
    index,
    isMobile = false,
    pageCol = 3,
}) => {
    const contentModule = useFragment(fragment, contentModuleRef);
    const storytellingModules = contentModule?.storytellingModules || [];

    if (!storytellingModules.length) {
        return null;
    }

    const config = getStorytellingModulesConfig(pageCol)[index];

    if (!config) {
        return null;
    }

    const module = storytellingModules[config.moduleIndex];

    if (!module) {
        return null;
    }
    const moduleKey = `${index}-${config.moduleIndex}`;
    return (
        <div key={moduleKey} className={styles.storytellingSlot}>
            <SbSharedContentModuleStorytellingCard
                module={module}
                isAlternate={config.isAlternate}
                isMobile={isMobile}
            />
        </div>
    );
};
